import * as types from "../constants/ActionTypes";

export const setScreenSize = (width, height) => ({
  type: types.SET_SCREEN_SIZE,
  width,
  height
});
